/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/CorporateStructureLink'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./CorporateStructureLink'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.SheetForecastFile = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.CorporateStructureLink);
  }
}(this, function(ApiClient, CorporateStructureLink) {
  'use strict';




  /**
   * The SheetForecastFile model module.
   * @module model/SheetForecastFile
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>SheetForecastFile</code>.
   * @alias module:model/SheetForecastFile
   * @class
   */
  var exports = function() {
    var _this = this;
























  };

  /**
   * Constructs a <code>SheetForecastFile</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SheetForecastFile} obj Optional instance to populate.
   * @return {module:model/SheetForecastFile} The populated <code>SheetForecastFile</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('ForecastID')) {
        obj['ForecastID'] = ApiClient.convertToType(data['ForecastID'], 'Integer');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('Note')) {
        obj['Note'] = ApiClient.convertToType(data['Note'], 'String');
      }
      if (data.hasOwnProperty('FatherID')) {
        obj['FatherID'] = ApiClient.convertToType(data['FatherID'], 'Integer');
      }
      if (data.hasOwnProperty('InputMethodID')) {
        obj['InputMethodID'] = ApiClient.convertToType(data['InputMethodID'], 'Integer');
      }
      if (data.hasOwnProperty('GoogleConfigurationID')) {
        obj['GoogleConfigurationID'] = ApiClient.convertToType(data['GoogleConfigurationID'], 'Integer');
      }
      if (data.hasOwnProperty('IsRolling')) {
        obj['IsRolling'] = ApiClient.convertToType(data['IsRolling'], 'Boolean');
      }
      if (data.hasOwnProperty('RollingNotificationsPeriodTypeID')) {
        obj['RollingNotificationsPeriodTypeID'] = ApiClient.convertToType(data['RollingNotificationsPeriodTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('RollingNotificationsDashboardPageID')) {
        obj['RollingNotificationsDashboardPageID'] = ApiClient.convertToType(data['RollingNotificationsDashboardPageID'], 'Integer');
      }
      if (data.hasOwnProperty('CorporateStructureLink')) {
        obj['CorporateStructureLink'] = CorporateStructureLink.constructFromObject(data['CorporateStructureLink']);
      }
      if (data.hasOwnProperty('ResponsibleUserID')) {
        obj['ResponsibleUserID'] = ApiClient.convertToType(data['ResponsibleUserID'], 'Integer');
      }
      if (data.hasOwnProperty('IsPrivate')) {
        obj['IsPrivate'] = ApiClient.convertToType(data['IsPrivate'], 'Boolean');
      }
      if (data.hasOwnProperty('StatusID')) {
        obj['StatusID'] = ApiClient.convertToType(data['StatusID'], 'Integer');
      }
      if (data.hasOwnProperty('ManagerNote')) {
        obj['ManagerNote'] = ApiClient.convertToType(data['ManagerNote'], 'String');
      }
      if (data.hasOwnProperty('ResponsibleUserNote')) {
        obj['ResponsibleUserNote'] = ApiClient.convertToType(data['ResponsibleUserNote'], 'String');
      }
      if (data.hasOwnProperty('LastUserUpdate')) {
        obj['LastUserUpdate'] = ApiClient.convertToType(data['LastUserUpdate'], 'Date');
      }
      if (data.hasOwnProperty('LastReminderSentDate')) {
        obj['LastReminderSentDate'] = ApiClient.convertToType(data['LastReminderSentDate'], 'Date');
      }
      if (data.hasOwnProperty('TypeID')) {
        obj['TypeID'] = ApiClient.convertToType(data['TypeID'], 'Integer');
      }
      if (data.hasOwnProperty('ErrorMessage')) {
        obj['ErrorMessage'] = ApiClient.convertToType(data['ErrorMessage'], 'String');
      }
      if (data.hasOwnProperty('LastErrorDate')) {
        obj['LastErrorDate'] = ApiClient.convertToType(data['LastErrorDate'], 'Date');
      }
      if (data.hasOwnProperty('SheetMessageStatusColumnToBudgetManager')) {
        obj['SheetMessageStatusColumnToBudgetManager'] = ApiClient.convertToType(data['SheetMessageStatusColumnToBudgetManager'], 'String');
      }
      if (data.hasOwnProperty('ExcelConfigurationID')) {
        obj['ExcelConfigurationID'] = ApiClient.convertToType(data['ExcelConfigurationID'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} ForecastID
   * @default 0
   */
  exports.prototype['ForecastID'] = 0;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {String} Note
   * @default ''
   */
  exports.prototype['Note'] = '';
  /**
   * @member {Integer} FatherID
   */
  exports.prototype['FatherID'] = undefined;
  /**
   * @member {Integer} InputMethodID
   */
  exports.prototype['InputMethodID'] = undefined;
  /**
   * @member {Integer} GoogleConfigurationID
   */
  exports.prototype['GoogleConfigurationID'] = undefined;
  /**
   * @member {Boolean} IsRolling
   * @default false
   */
  exports.prototype['IsRolling'] = false;
  /**
   * @member {Integer} RollingNotificationsPeriodTypeID
   */
  exports.prototype['RollingNotificationsPeriodTypeID'] = undefined;
  /**
   * @member {Integer} RollingNotificationsDashboardPageID
   */
  exports.prototype['RollingNotificationsDashboardPageID'] = undefined;
  /**
   * @member {module:model/CorporateStructureLink} CorporateStructureLink
   */
  exports.prototype['CorporateStructureLink'] = undefined;
  /**
   * @member {Integer} ResponsibleUserID
   */
  exports.prototype['ResponsibleUserID'] = undefined;
  /**
   * @member {Boolean} IsPrivate
   * @default false
   */
  exports.prototype['IsPrivate'] = false;
  /**
   * @member {Integer} StatusID
   * @default 0
   */
  exports.prototype['StatusID'] = 0;
  /**
   * @member {String} ManagerNote
   * @default ''
   */
  exports.prototype['ManagerNote'] = '';
  /**
   * @member {String} ResponsibleUserNote
   * @default ''
   */
  exports.prototype['ResponsibleUserNote'] = '';
  /**
   * @member {Date} LastUserUpdate
   */
  exports.prototype['LastUserUpdate'] = undefined;
  /**
   * @member {Date} LastReminderSentDate
   */
  exports.prototype['LastReminderSentDate'] = undefined;
  /**
   * @member {Integer} TypeID
   * @default 0
   */
  exports.prototype['TypeID'] = 0;
  /**
   * @member {String} ErrorMessage
   * @default ''
   */
  exports.prototype['ErrorMessage'] = '';
  /**
   * @member {Date} LastErrorDate
   */
  exports.prototype['LastErrorDate'] = undefined;
  /**
   * @member {String} SheetMessageStatusColumnToBudgetManager
   * @default ''
   */
  exports.prototype['SheetMessageStatusColumnToBudgetManager'] = '';
  /**
   * @member {Integer} ExcelConfigurationID
   */
  exports.prototype['ExcelConfigurationID'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


